import React from 'react';
import Styles from './styles.js';
const AmenityBig = ({ title, img, bgImg, lansdowne }) => {
  return (
    <div>
      {lansdowne == true ? (
        <div
          className={img}
          style={{
            paddingTop: '4.5rem',
            paddingBottom: '11rem',
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%), url(${bgImg})`,
          }}>
          <div className="">
            <h5
              className="card-title fs-card-res text-center fw-400 "
              style={{ fontFamily: 'josefin Sans', color: 'white' }}>
              {title}
            </h5>
          </div>
        </div>
      ) : (
        <div
          className={img}
          style={{
            paddingTop: '5.8rem',
            paddingBottom: '10.5rem',
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%), url(${bgImg})`,
          }}>
          <div className="">
            <h5
              className="card-title fs-card-res text-center fw-400 "
              style={{ fontFamily: 'josefin Sans', color: 'white' }}>
              {title}
            </h5>
          </div>
        </div>
      )}
      <Styles/>
    </div>
  );
};

export default AmenityBig;
